/**
 * User-facing name for the /m phone client (APK + PWA).
 * Keep technical paths (/m, field-progress scripts, package ids) unchanged.
 */

export const MOBILE_APP_NAME = 'LGL Portal';
export const MOBILE_APP_BACK_LABEL = `Back to ${MOBILE_APP_NAME}`;
export const MOBILE_APP_KICKER = 'LGL Portal';
